<mat-card appearance="outlined">
  <div class="adverse-party-details">
    <div class="details-wrapper">
      <div class="detail-fields container-elevated">
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <span class="label whitespace-no-wrap">Subro File Type</span>
            @if (adverseParty.subroFileTypeCode) {
            <p>
              {{
                displayDescription(
                  adverseParty.subroFileTypeCode,
                  detailCodes?.fileTypeCodes
                ).toLowerCase()
              }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div data-pgr-id="ap-judgement-entered" class="col-md-3 col-sm-6">
            <span class="label">Judgment Entered</span>
            @if ( adverseParty.judgmentEnteredIndicator) {
            <p>
              {{ adverseParty.judgmentEnteredIndicator }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div class="col-md-3 col-sm-6">
            <span class="label">Claimant Carrier Liability Decision</span>
            @if ( adverseParty.insuranceCarrierInfo?.liabilityDecision) {
            <p>
              {{
                displayDescription(
                  adverseParty.insuranceCarrierInfo?.liabilityDecision,
                  detailCodes?.liabilityDecisionTypeCodes
                )
              }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div class="col-md-3 col-sm-6">
            <span class="label">
              Claimant Carrier Liability Limits Sufficient
            </span>
            @if ( adverseParty.insuranceCarrierInfo?.liabilityLimitsSufficient)
            {
            <p>
              {{
                getLiabilityLimitsText(
                  adverseParty.insuranceCarrierInfo?.liabilityLimitsSufficient
                )
              }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <span class="label">Deductible Status</span>
            @if ( adverseParty.deductibleStatusCode) {
            <p>
              {{
                displayDescription(
                  adverseParty.deductibleStatusCode,
                  detailCodes?.deductibleStatusCodes
                ).toLowerCase()
              }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div class="col-md-3 col-sm-6">
            <span class="label whitespace-no-wrap">Agency / Attorney</span>
            @if (adverseParty.agency) {
            <p>
              {{
                displayDescription(
                  adverseParty.agency,
                  detailCodes?.attorneyNicknames
                ).toLowerCase()
              }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div data-pgr-id="ap-percent-disputed" class="col-md-3 col-sm-6">
            <span class="label">% Disputed</span>
            @if ( adverseParty.insuranceCarrierInfo?.liabilityDisputedAmount) {
            <p>
              {{ adverseParty.insuranceCarrierInfo?.liabilityDisputedAmount }}
            </p>
            } @else {
            <p>&mdash;</p>
            }
          </div>
          <div class="col-md-3 col-sm-6">
            <!-- Empty for styling purposes -->
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
<cla-subro-features
  [adversePartyName]="adverseParty | claPartyName"
  [partyId]="adverseParty.partyId"
  [partySequenceNumber]="adverseParty.partySequenceNumber"
  [subroObligationId]="adverseParty.subroObligationId"
  [liabilityPercentage]="adverseParty.liabilityPercentage"
  [claimNumber]="claimNumber"
  [detailCodes]="detailCodes"
></cla-subro-features>
